// Sonidos de confirmación para trabajo en corral (Web Audio, sin archivos, funciona offline)
const PREF_KEY = 'tkorvex_sonidos';
let ctx = null;

export const sonidosActivos = () => localStorage.getItem(PREF_KEY) !== 'off';
export const setSonidosActivos = (on) => localStorage.setItem(PREF_KEY, on ? 'on' : 'off');

const getCtx = () => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};

const tono = (ac, freq, inicio, dur, tipo = 'sine', vol = 0.25) => {
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.type = tipo;
  osc.frequency.setValueAtTime(freq, inicio);
  gain.gain.setValueAtTime(0.0001, inicio);
  gain.gain.exponentialRampToValueAtTime(vol, inicio + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, inicio + dur);
  osc.connect(gain).connect(ac.destination);
  osc.start(inicio);
  osc.stop(inicio + dur + 0.02);
};

// "Ding" ascendente: registro exitoso
export const sonidoExito = () => {
  if (!sonidosActivos()) return;
  const ac = getCtx();
  if (!ac) return;
  const t = ac.currentTime;
  tono(ac, 880, t, 0.12);
  tono(ac, 1320, t + 0.1, 0.22);
};

// Tono descendente: animal no encontrado (hay que darlo de alta)
export const sonidoNoEncontrado = () => {
  if (!sonidosActivos()) return;
  const ac = getCtx();
  if (!ac) return;
  const t = ac.currentTime;
  tono(ac, 520, t, 0.14, 'triangle');
  tono(ac, 360, t + 0.15, 0.28, 'triangle');
};
